module.exports = __webpack_public_path__ + "static/media/VINATI JI 03.2318a668.jpg";